import { z } from 'zod';

export const workingHoursSchema = z.object({
  weekday: z.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']),
  openingTime: z.string(),
  closingTime: z.string(),
});

export const createBranchRequestSchema = z.object({
  name: z.string(),
  phoneNumber: z.string().optional(),
  latitude: z.number(),
  longitude: z.number(),
  cityId: z.string().optional(),
  countyId: z.string().optional(),
  address: z.string(),
  availabilityStatus: z.enum(['OpeningSoon', 'UnderMaintenance', 'Open']).optional(),
  workingHours: z.array(workingHoursSchema).optional(),
});

export const createBranchResponseSchema = z.any();

export const updateBranchRequestSchema = z.object({
  name: z.string(),
  phoneNumber: z.string().optional(),
  latitude: z.number(),
  longitude: z.number(),
  cityId: z.string().optional(),
  countyId: z.string().optional(),
  address: z.string(),
  availabilityStatus: z.enum(['OpeningSoon', 'UnderMaintenance', 'Open']).optional(),
  workingHours: z.array(workingHoursSchema).optional(),
});

export const updateBranchResponseSchema = z.any();

export const deleteBranchRequestSchema = z.array(z.object({ id: z.string() }));

export const deleteBranchResponseSchema = z.any();

export const listBranchesRequestSchema = z.object({
  SearchText: z.string().optional(),
  PageNumber: z.number().optional(),
  PageSize: z.number().optional(),
  OrderColumn: z.string().optional(),
  OrderType: z.string().optional(),
});

export const listBranchesResponseSchema = z.object({
  totalCount: z.number(),
  result: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    })
  ),
});

export const branchDetailResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  phoneNumber: z.string().nullable(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  cityId: z.string().nullable(),
  countyId: z.string().nullable(),
  address: z.string().nullable(),
  availabilityStatus: z.enum(['OpeningSoon', 'UnderMaintenance', 'Open', 'Closed']).nullable(),
  workingHours: z.array(workingHoursSchema).nullable(),
});

export type WorkingHours = z.infer<typeof workingHoursSchema>;
export type CreateBranchRequest = z.infer<typeof createBranchRequestSchema>;
export type CreateBranchResponse = z.infer<typeof createBranchResponseSchema>;
export type UpdateBranchRequest = z.infer<typeof updateBranchRequestSchema>;
export type UpdateBranchResponse = z.infer<typeof updateBranchResponseSchema>;
export type DeleteBranchRequest = z.infer<typeof deleteBranchRequestSchema>;
export type DeleteBranchResponse = z.infer<typeof deleteBranchResponseSchema>;
export type ListBranchesRequest = z.infer<typeof listBranchesRequestSchema>;
export type ListBranchesResponse = z.infer<typeof listBranchesResponseSchema>;
export type BranchDetailResponse = z.infer<typeof branchDetailResponseSchema>;

export const getBranchTemplateFileResponseSchema = z.any();

export type GetBranchTemplateFileResponse = z.infer<typeof getBranchTemplateFileResponseSchema>;

export const importExcelRequestSchema = z.object({
  file: z.any(), // File object
});

export const importExcelResponseSchema = z.any();

export type ImportExcelRequest = z.infer<typeof importExcelRequestSchema>;
export type ImportExcelResponse = z.infer<typeof importExcelResponseSchema>;

export const cityDropdownItemSchema = z.object({
  key: z.string(),
  value: z.string(),
});

export const citiesDropdownResponseSchema = z.array(cityDropdownItemSchema);

export type CityDropdownItem = z.infer<typeof cityDropdownItemSchema>;
export type CitiesDropdownResponse = z.infer<typeof citiesDropdownResponseSchema>;

export const countyDropdownItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  cityId: z.string(),
});

export const countiesDropdownResponseSchema = z.array(countyDropdownItemSchema);

export type CountyDropdownItem = z.infer<typeof countyDropdownItemSchema>;
export type CountiesDropdownResponse = z.infer<typeof countiesDropdownResponseSchema>;

